import { render, staticRenderFns } from "./SubscriptionPolicies.vue?vue&type=template&id=d612d2b0&scoped=true&"
import script from "./SubscriptionPolicies.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPolicies.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPolicies.vue?vue&type=style&index=0&id=d612d2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d612d2b0",
  null
  
)

export default component.exports